import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Typography from '@material-ui/core/Typography';
import {cloneDeep} from 'lodash';
import {isExistApplicantExam, findExamTypeIndex} from '@helpers/find';
import {configExamTypesTranslatedConf} from '../../../config/exams';
import {Done} from '@material-ui/icons';
import '@scss/zajavls.scss';
import {withTranslation} from "react-i18next";

class ContestExams extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const {constestExams, applicantExams, i18n, t} = this.props;
        const currentLang = i18n.language;

        return constestExams.length
            ?
            constestExams.map((priority, priorityNum) => {
                const isFind = isExistApplicantExam(applicantExams, priority.exams);
                return (
                    <div variant="body1" key={priority.priority_id}>
                        <Typography variant="body1" key={priority.priority_id}>
                            {Number(priorityNum) + 1})&nbsp;
                            {priority.exams.map((exam) => {
                                return currentLang === 'en' && exam.exam_name_en ? exam.exam_name_en : exam.exam_name
                            }).join('/')}

                            {isFind
                                ? <span className="success"> <Done/></span>
                                : <span className="danger"> {t('missing')}</span>}
                        </Typography>
                        <ul>
                            {priority.exams.map((exam) => {
                                return exam.type_rows.map((typeRow) => {
                                    const idx = findExamTypeIndex(configExamTypesTranslatedConf, Number(typeRow.type));
                                    return idx !== -1
                                        ? <li key={typeRow.id}> {t(configExamTypesTranslatedConf[idx].name)} ({t('minimum_score')} {typeRow.min_ball} )</li>
                                        : null;
                                });
                            })}
                        </ul>
                    </div>
                )
            })
            : <Typography variant="body1">
                {currentLang === 'en'
                    ? <>
                        No entrance exams are assigned for applicants with your education level.<br/>
                        You can change your education level on the <a href="#/profile">General Information</a> page.
                    </>
                    : <>
                        Не назначены вступительные испытания для абитуриентов с Вашим уровнем образования.<br/>
                        Изменить уровень образования Вы можете на странице <a href="#/profile">Основные сведения</a>
                    </>
                }
            </Typography>
    }
}

function mapStateToProps(state) {
    return {
        applicantExams: cloneDeep(state.applicantExams),
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ContestExams));